import React from "react"
import { navigate } from "gatsby"
import { Swipeable } from 'react-swipeable'

import Homepage from '../components/homepage';

import SEO from "../components/Common/seo";
import App from '../components/app';

import "../components/reset.css";
import "../components/base.css";

const IndexPage = () => {
  const switchPage = index => {
    if (index < 0 | index > 2) {
      return;
    }
    switch(index) {
      case 0:
        navigate("/lor/");
        break;
      case 1:
        navigate("/");
        break;
      case 2:
        navigate("/tft/");
        break;
      default:
        break;
    }
  }

  
  return (
    <>
      <SEO 
        title="top | MINDMASTERS 2020"
        description="マインドマスターズとは、合同会社ライアットゲームズ による「レジェンド・オブ・ルーンテラ」及び「チームファイト タクティクス」の日本全国を対象にした大会です。"
        lang="jp"
      />
      <Swipeable delta={50} onSwipedLeft={() => document.getElementById("tftNavButton").click()} onSwipedRight={() => document.getElementById("lorNavButton").click()}>
        <App>
          <Homepage onNavigation={switchPage}/>
        </App>
      </Swipeable>
    </>
   
  )
};

export default IndexPage
